import { Component, OnInit, Input, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {

  @Input()
  headerDetails: HeaderDetails;

  constructor() { }

  ngOnInit() {}

  ngOnChanges(changes: SimpleChanges) {}
}

export interface HeaderDetails {
    title: string,
    description: string,
    img:string
}
